import React from 'react';
import { Document, Page, StyleSheet, View, Text } from '@react-pdf/renderer';
import UldDetailsTable from './UldDetailsTable';
import Footer from './Footer';
import moment from 'moment';
import cookies from 'utils/cookies';
import { DateFormat } from 'custom/constants';

const timezone = cookies.get('timezone') || null;
const station_code = cookies.get('station_code') || null;

const uldDetails = {
  trans_date: timezone? moment().tz(timezone).format('DDMMMYYYY')?.toUpperCase() : null, 
  station: station_code,
};

const primaryBlue = '#092b4a';

const styles = StyleSheet.create({
  page: {
    fontSize: 11,
    paddingTop: 30,
    paddingLeft:60,
    paddingRight:60,
    lineHeight: 1.5,
    flexDirection: 'column',
    paddingBottom: 65,
    paddingHorizontal: 35,
  }, 
  titleContainer:{
    flexDirection: 'row',
    justifyContent: 'space-between', 
    alignItems: 'center',
    margin: '-30px -35px 10px -35px',
    padding: '10px 0 10px 35px',
    color: primaryBlue,
    borderBottom: `1px solid ${primaryBlue}`,
    backgroundColor: primaryBlue,
  },
  titleContent: {
    alignItems: 'flex-start',
    textAlign: 'left' ,
    backgroundColor: primaryBlue,
    color: 'white',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 8,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  date: { fontSize: 10, },
  uldDetailsLabel: {
    fontSize: 14,
    textTransform: 'uppercase',
    lineHeight: 'normal',
    paddingBottom: 2,
    fontFamily: 'NunitoRegular',
  },  
  column: { flexDirection: 'column', },
  row: { flexDirection: 'row', },
  alignItemsCenter: { alignItems: 'center' },
  logoWrapper: {
    backgroundColor: 'white',
    borderBottomLeftRadius: 20,
    paddingLeft: 20, 
    paddingRight: 20,
    minHeight: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoContainer: {
    alignItems: 'flex-end',
    backgroundColor: primaryBlue,
  },
  logo: {
    width: 80,
    height: 'auto',
  },
});

const MyDocument = (props) => {
  const { uld, flight, accessories } = props;

  return (
    <Document>
      <Page size='A4' style={styles.page} wrap={true}>
        <View style={[styles.titleContainer]}>
          <View style={[styles.column,styles.titleContent]}>
            <View style={[styles.row, styles.alignItemsCenter]}>
              <Text style={styles.uldDetailsLabel}>{`ULD Loading Details - ${flight?.airline?.code}${flight?.flight_no}/${moment(flight?.flight_date).format(DateFormat)}`}</Text>
            </View>
            <Text style={[styles.date, { paddingBottom: 2, }]}>{props.ctype}</Text>
            <Text style={styles.date}>{uldDetails.trans_date} | {uldDetails.station}</Text>
          </View>
          <View style={[styles.column, styles.logoContainer]}>
            {/* <View style={styles.logoWrapper}>
              <Image
                src={props.airlineLogo}
                style={styles.logo}
              />
            </View> */}
          </View>
        </View>

        <UldDetailsTable awbs={uld.buildup_awb} uld_no={uld.uld_no} />
        <Footer uld={uld} accessories={accessories} />
  
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
  
      </Page>
    </Document>
  );
};

export default MyDocument;
